import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowPointer,
  faBriefcase,
  faClipboardUser,
  faGears,
  faPeopleGroup,
} from "@fortawesome/sharp-regular-svg-icons";
import { StepIconProps } from "@mui/material";
import { StyledStepIconRoot } from "./internals/StyledStepIconRoot";

export function StyledStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const completedIconFillColor = "#050505";
  const icons: { [index: string]: React.ReactElement } = {
    1: !completed ? (
      <FontAwesomeIcon icon={faArrowPointer} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faArrowPointer} />
    ),
    2: !completed ? (
      <FontAwesomeIcon icon={faBriefcase} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faBriefcase} />
    ),
    3: !completed ? (
      <FontAwesomeIcon icon={faPeopleGroup} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faPeopleGroup} />
    ),
    4: !completed ? (
      <FontAwesomeIcon icon={faClipboardUser} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faClipboardUser} />
    ),
    5: !completed ? (
      <FontAwesomeIcon icon={faGears} style={{ color: completedIconFillColor }} />
    ) : (
      <FontAwesomeIcon icon={faGears} />
    ),
  };

  return (
    <StyledStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </StyledStepIconRoot>
  );
}
